export const environment = {
  production: false,
  WebApiUrl: 'https://api-internal.mctradestage.com',
  WeblinkAuthUrl: 'https://auth.mctradestage.com',
  PersonifyIdpDomain: 'https://stage.psfyidp.com',
  IDPBaseUrl: '',
};
